import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Résultat unitaire d'une ressource dispatchée avec succès */
export interface DispatchSuccess {
  id: number;
  filename: string;
}

/** Résultat unitaire d'une ressource en échec */
export interface DispatchFailure {
  id: number;
  filename: string;
  reason: string;
}

/** État de progression d'un job de dispatch (renvoyé par /status) */
export interface DispatchStatus {
  id: string;
  type: string;
  idOuvrage: number | null;
  userId: number | null;
  total: number;
  processed: number;
  successCount: number;
  failureCount: number;
  successes: DispatchSuccess[];
  failures: DispatchFailure[];
  errors: string[];
  done: boolean;
  startedAt: number;
  finishedAt: number | null;
}

/** Réponse au lancement d'un dispatch */
export interface DispatchJob {
  jobId: string;
  total: number;
}

/**
 * Service d'accès aux endpoints de dispatch des ressources numériques (MAX, ...).
 * L'authentification est gérée par l'intercepteur HTTP global.
 */
@Injectable({
  providedIn: 'root',
})
export class DispatchService {
  constructor(private http: HttpClient) {}

  /** Structures dispatchables d'un ouvrage pour un type donné */
  getStructures(type: string, idOuvrage: number): Observable<{ structures: string[] }> {
    return this.http.get<{ structures: string[] }>(
      `${environment.apiUrl}/api/dispatch/${type}/structures/${idOuvrage}`,
    );
  }

  /** Lance (en asynchrone) le dispatch des structures sélectionnées */
  dispatch(type: string, idOuvrage: number, structures: string[]): Observable<DispatchJob> {
    return this.http.post<DispatchJob>(`${environment.apiUrl}/api/dispatch/${type}`, {
      idOuvrage,
      structures,
    });
  }

  /** Récupère l'état de progression d'un job */
  getStatus(jobId: string): Observable<DispatchStatus> {
    return this.http.get<DispatchStatus>(`${environment.apiUrl}/api/dispatch/status/${jobId}`);
  }
}
